import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Phone, MapPin } from 'lucide-react';
export function ThankYou() {
  return <div className="min-h-[70vh] bg-off-white flex items-center justify-center py-24" data-id="element-985">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-986">
        <div className="w-20 h-20 bg-storm-red/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-987">
          <CheckCircle className="w-10 h-10 text-storm-red" data-id="element-988" />
        </div>

        <h1 className="text-5xl text-ink mb-6" data-id="element-989">
          Your Free Trial Request Has Been Received
        </h1>

        <p className="text-xl text-gray-warm mb-12 leading-relaxed" data-id="element-990">
          Storm Taekwondo will contact you soon to confirm the best class time
          and next steps. We look forward to meeting you!
        </p>

        <div className="bg-paper p-8 rounded-2xl shadow-soft border border-subtle-gray flex flex-col sm:flex-row justify-center gap-8 mb-12" data-id="element-991">
          <div className="flex flex-col items-center gap-2" data-id="element-992">
            <Phone className="w-6 h-6 text-storm-red" data-id="element-993" />
            <span className="font-bold text-ink" data-id="element-994">Questions? Call Us</span>
            <a href="tel:517-220-0621" className="text-gray-warm hover:text-storm-red transition-colors" data-id="element-995">
              517-220-0621
            </a>
          </div>
          <div className="hidden sm:block w-px bg-subtle-gray" data-id="element-996"></div>
          <div className="flex flex-col items-center gap-2" data-id="element-997">
            <MapPin className="w-6 h-6 text-storm-red" data-id="element-998" />
            <span className="font-bold text-ink" data-id="element-999">Location</span>
            <span className="text-gray-warm text-center" data-id="element-1000">
              24786 Crestview
              <br data-id="element-1001" />
              Farmington Hills, MI
            </span>
          </div>
        </div>

        <Link to="/" className="btn-outline" data-id="element-1002">
          Return to Homepage
        </Link>
      </div>
    </div>;
}